import { Component, OnInit, ViewChild, AfterViewChecked, inject, ElementRef } from '@angular/core';
import { StartService } from 'src/app/core/services/start-service.service';
import { AccreditedRoleService } from 'src/app/core/services/accredited-role.service';
import { User } from 'src/app/core/classes/user';
import { FormBuilder, Validators } from '@angular/forms';
import { AppConfigService } from 'src/app/app-config.service';
import { CookieService } from 'ngx-cookie-service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Splide } from '@splidejs/splide';
import 'src/assets/css/splide.min.css';
import 'src/assets/css/splide-core.min.css';
import 'src/assets/css/splide-default.min.css';
import {
  FaqItem,
  FAQ_DATA,
  FAQ_DATA_TRADER,
} from 'src/app/core/interfaces/faq.interface';
import RU from '../../../assets/i18n/RU.json';
import EN from '../../../assets/i18n/EN.json';
import { DomSanitizer } from '@angular/platform-browser';
import { DxHtmlEditorComponent } from 'devextreme-angular';
import { AuctionType, IdDirection, IdSection } from 'src/app/constants';
import { PageMetaService } from '../../utils/page-meta/page-meta.service';
import { ISessionLoginRes, ApiDataSection } from '../../core/interfaces';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { initializeApiData, selectApiDataSections } from '../../core/store/api-data';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})

export class HomepageComponent implements OnInit, AfterViewChecked {
  @ViewChild(DxHtmlEditorComponent) editor!: DxHtmlEditorComponent;
  @ViewChild('newsWrapper') newsWrapper!: ElementRef;

  user: User;
  public sections$: Observable<ApiDataSection[]>;
  filterTab: number = 0;
  filterSessionsId: number = 1; //для фильтрации сессий
  sessions: any;
  sessionsForDisplay: any;
  news: any;
  fullNews: any;
  pageSize: number = 20;
  numberEntriesPage = [10, 20, 50, 100];
  currentPage: number = 1;
  totalPages: number;
  editNewsBody: boolean = false;
  newsContent: string;
  titleNews: string;
  currentTimeDate: Date;
  loadingVisible: boolean = false; //лодер
  editDisable: boolean = false; //для кнопки добавить новость
  disabledDates: any;
  today = Date();
  locale: string;
  guide: any;
  guideElements: any;
  guideElementsForDisplay: any;
  selectedGuide: number;

  Privileges: boolean = false;
  isExistsViolations: boolean;

  errorMessage: string;

  formActive = this.formBuilder.group({
    onlyActive: [true],
  });

  form = this.formBuilder.group({
    newsContent: ['', Validators.required],
    titleNews: [null, Validators.required],
    datePublish: [],
  });

  formEdit = this.formBuilder.group({
    idNews: [null, Validators.required],
    newsContent: ['', Validators.required],
    titleNews: [null, Validators.required],
    datePublish: [],
  });

  isEdit = false;
  addNewsBody: boolean = false;
  acceptedPointSizeValues = ['10pt'];
  acceptedFontValues = ['Roboto'];
  private hasFormatted = false;
  newsContents = '';
  editingNewsId: number | null = null;
  private savedScrollY = 0;

  cookieService = inject(CookieService);

  isTraderActive: boolean = false;
  isWorkerActive: boolean = false;

  catalogVisible: boolean = false;

  topics;
  faqs: FaqItem[];
  faqsForDisplay;

  searchTerm: string = '';

  public readonly IdDirection = IdDirection;
  public readonly IdSection = IdSection;

  constructor(
    private startService: StartService,
    private store: Store,
    public translate: TranslateService,
    private formBuilder: FormBuilder,
    private config: AppConfigService,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private readonly accreditedRoleService: AccreditedRoleService,
    private pageMeta: PageMetaService
  ) {
    this.locale = this.translate.currentLang;
    this.setBrowserTabInfo();

    this.guide = [
      {
        id: 1,
        title: 'Аккредитация',
        selected: true,
      },
      {
        id: 2,
        title: 'Торги',
        selected: false,
      },
      {
        id: 3,
        title: 'Персональный раздел',
        selected: false,
      },
      {
        id: 4,
        title: 'Электронные документы',
        selected: false,
      },
      {
        id: 5,
        title: 'Иное',
        selected: false,
      },
    ];

    this.guideElements = [
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Аккредитация"',
        path: 'assets/UserGuide_PersonalPage(accreditation).pdf',
        size: '1.55 Mb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Аккредитация"',
        path: 'assets/UserGuide_PersonalPage(accreditation(short)).pdf',
        size: '390.32 Kb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Аккредитация (клиент брокера)"',
        path: 'assets/UserGuidePersonalPage(accreditation(client-docum)).pdf',
        size: '283.32 Kb',
        type: 'pdf',
      },
      {
        parentId: 1,
        forTrader: true,
        forWorker: true,
        name: 'Обучающий ролик по разделу "Аккредитация"',
        path: 'https://www.youtube.com/watch?v=4-ewLLTsGHA',
        size: '',
        type: 'video',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Краткая инструкция по работе в «Новой торговой системе» (для трейдера)',
        path: 'assets/UserGuide_NTS_(trader).pdf',
        size: '1.23 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Общее описание единого биржевого пространства» (для трейдера)',
        path: 'assets/UserGuide_UAS_(trader).pdf',
        size: '3,30 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Подсистема управления заявками» (для трейдера)',
        path: 'assets/UserGuide_OrderManagement_(trader).pdf',
        size: '2.18 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: true,
        forWorker: false,
        name: 'Руководство пользователя «Подсистема управления торгами (для трейдера)',
        path: 'assets/UserGuide_TradingSystem_(trader).pdf',
        size: '2.18 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Краткая инструкция по работе_Новая торговая система (для работника)',
        path: 'assets/UserGuide_NTS(worker).pdf',
        size: '2.48 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Руководство пользователя_Единое биржевое пространство (для работника)',
        path: 'assets/UserGuide_EBP(worker).pdf',
        size: '7,93 Mb',
        type: 'pdf',
      },
      {
        parentId: 2,
        forTrader: false,
        forWorker: true,
        name: 'Руководство пользователя_Подсистема управления торгами (для работника)',
        path: 'assets/UserGuide_TradingSystem(worker).pdf',
        size: '4.58 Mb',
        type: 'pdf',
      },
      {
        parentId: 3,
        forTrader: true,
        forWorker: true,
        name: 'Общая инструкция для работы в приложении (для участника)',
        path: 'assets/UserGuide_PersonalPage(user).pdf',
        size: '1.24 Mb',
        type: 'pdf',
      },
      {
        parentId: 3,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Каталог товаров"',
        path: 'assets/UserGuide_PersonalPage(сatalog).pdf',
        size: '309.17 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Электронные документы"',
        path: 'assets/UserGuide_PersonalPage(electronicworkflow).pdf',
        size: '1.96 Mb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Электронные документы"',
        path: 'assets/UserGuide_PersonalPage(electronicworkflow(short)).pdf',
        size: '485.84 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Краткая инструкция по разделу "Реестры"',
        path: 'assets/UserGuide_PersonalPage(reestrs(short)).pdf',
        size: '279.61 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Инфоподписки"',
        path: 'assets/UserGuide_PersonalPage(subscription).pdf',
        size: '141.58 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Допуск в торги"',
        path: 'assets/UserGuide_PersonalPage(admission).pdf',
        size: '216.92 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Контроль исполнения"',
        path: 'assets/UserGuide_PersonalPage(obligations).pdf',
        size: '466.63 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по разделу "Финансовые документы"',
        path: 'assets/UserGuide_PersonalPage(financedocs).pdf',
        size: '625.13 Kb',
        type: 'pdf',
      },
      {
        parentId: 4,
        forTrader: true,
        forWorker: true,
        name: 'Обучающий ролик по электронному документообороту',
        path: `${this.config.ppUrl}/Content/static/pp_edu.mp4`,
        size: '',
        type: 'video',
      },
      {
        parentId: 5,
        forTrader: true,
        forWorker: true,
        name: 'Контакты отделов биржи',
        path: 'https://www.butb.by/kontakt-tsentr/kontakty/',
        size: '',
        type: 'link',
      },
      {
        parentId: 5,
        forTrader: true,
        forWorker: true,
        name: 'Инструкция по работе с ЭЦП',
        path: `${this.config.ppUrl}/UserGuide/HelpLoginDS`,
        size: '',
        type: 'link',
      },
    ];
  }

  openAddForm(): void {
    this.addNewsBody = true;
    this.hasFormatted = false;

    this.newsContents = `
      <p style="font-family: ${this.acceptedFontValues[0]}; font-size: ${this.acceptedPointSizeValues[0]};">&nbsp;</p>`;
    this.form.get('newsContent')?.setValue(this.newsContents);
  }

  ngAfterViewChecked(): void {
    if (this.addNewsBody && this.editor?.instance && !this.hasFormatted) {
      const editorInstance = this.editor.instance;

      editorInstance.setSelection(1, 0);

      editorInstance.format('size', this.acceptedPointSizeValues[0]);
      editorInstance.format('font', this.acceptedFontValues[0]);

      editorInstance.insertText(0, '', false);

      this.hasFormatted = true;
    }
  }

  handleEditorChange(e: any): void {
    const content = e.value?.trim();

    const isEmpty = !content || content === '' || content === '<p><br></p>' || content === '<p>&nbsp;</p>';

    if (isEmpty) {
      this.newsContents = `<p style="font-family: ${this.acceptedFontValues[0]}; font-size: ${this.acceptedPointSizeValues[0]};">&nbsp;</p>`;
      this.form.get('newsContent')?.setValue(this.newsContents);
    }
  }

  private setBrowserTabInfo(): void {
    const LANDING_PAGE =
      this.translate.store.currentLang === 'RU'
        ? RU['general'].homePage
        : EN['general'].homePage;

    const faviconUrl = 'assets/img/icons/logo.svg';
    this.pageMeta.setPageMeta(null, LANDING_PAGE, faviconUrl);
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.user.IsWorker) {
      this.Privileges = this.startService.checkPrivileges('NewsEditItem');
      this.isTraderActive = false;
      this.isWorkerActive = true;
      this.topics = [
        {
          title: 'Каталог',
          expanded: true,
          items: [
            {
              id: '1.1',
              heading: 'Каталог спроса/Каталог предложений',
              selected: true,
            },
          ],
        },
        {
          title: 'Сессии',
          expanded: false,
          items: [
            {
              id: '2.1',
              heading: 'Расписание сессий',
              selected: false,
            },
            {
              id: '2.2',
              heading: 'Создание сессий',
              selected: false,
            },
            {
              id: '2.3',
              heading: 'Создание шаблона сессии',
              selected: false,
            },
            {
              id: '2.4',
              heading: 'Просмотр сессии, шаблонов сессии',
              selected: false,
            },
            {
              id: '2.5',
              heading:
                'Копирование, редактирование, удаление сессии, шаблона сессии',
              selected: false,
            },
            {
              id: '2.6',
              heading: 'Синхронизация сессии',
              selected: false,
            },
            {
              id: '2.7',
              heading:
                'Перевод в стадию «Открыт прием заявок…», завершение обработки заявок',
              selected: false,
            },
            {
              id: '2.8',
              heading: 'Перенос в торги, в архив',
              selected: false,
            },
          ],
        },
        {
          title: 'Заявки',
          expanded: false,
          items: [
            {
              id: '3.1',
              heading: 'Управление заявками',
              selected: false,
            },
            {
              id: '3.2',
              heading: 'Конструктор моделей',
              selected: false,
            },
            {
              id: '3.3',
              heading: 'Конструктор правил',
              selected: false,
            },
            {
              id: '3.4',
              heading: 'Архив',
              selected: false,
            },
          ],
        },
        {
          title: 'Торги сегодня',
          expanded: false,
          items: [
            {
              id: '4.1',
              heading: 'Торги',
              selected: false,
            },
            {
              id: '4.2',
              heading: 'Период сессии',
              selected: false,
            },
            {
              id: '4.3',
              heading: 'Шаг цены',
              selected: false,
            },
            {
              id: '4.4',
              heading: 'Ставки',
              selected: false,
            },
            {
              id: '4.5',
              heading: 'Регистрации',
              selected: false,
            },
            {
              id: '4.6',
              heading: 'Трейдеры',
              selected: false,
            },
            {
              id: '4.7',
              heading: 'Заявки',
              selected: false,
            },
            {
              id: '4.8',
              heading: 'Задаток',
              selected: false,
            },
            {
              id: '4.9',
              heading: 'Встречные предложения',
              selected: false,
            },
            {
              id: '4.10',
              heading: 'Сделки',
              selected: false,
            },
            {
              id: '4.11',
              heading: 'Сообщения',
              selected: false,
            },
            {
              id: '4.12',
              heading: 'Допуск в торги',
              selected: false,
            },
            {
              id: '4.13',
              heading: 'Настройки',
              selected: false,
            },
            {
              id: '4.14',
              heading: 'Товары-аналоги',
              selected: false,
            },
            {
              id: '4.15',
              heading: 'Перенос в архив',
              selected: false,
            },
          ],
        },
      ];

      this.faqs = FAQ_DATA;

      this.faqsForDisplay = this.faqs.filter((i) => {
        return i.topicId === '1.1';
      });

      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forWorker === true && i.parentId == 1;
      });
    }
    if (this.user?.token && !this.user.IsWorker) {
      this.errorMessage = this.cookieService.get('UasMessage');
    }
    if (!this.user?.token || !this.user.IsWorker) {
      this.topics = [
        {
          title: 'Каталог',
          expanded: true,
          items: [
            {
              id: '1.1',
              heading: 'Переход в Каталог спроса/Каталог предложений',
              selected: true,
            },
            {
              id: '1.2',
              heading: 'Просмотр, редактирование, отмена заявки',
              selected: false,
            },
            {
              id: '1.3',
              heading: 'Регистрация/отмена регистрации на сессию',
              selected: false,
            },
            {
              id: '1.4',
              heading: 'Подача заявки на покупку/продажу',
              selected: false,
            },
            {
              id: '1.5',
              heading: 'Просмотр сумма задатка по заявке/на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Расписание сессий',
          expanded: false,
          items: [
            {
              id: '2.1',
              heading: 'Просмотр расписания сессий, заявок',
              selected: false,
            },
            {
              id: '2.2',
              heading: 'Просмотр суммы задатка на сессию',
              selected: false,
            },
            {
              id: '2.3',
              heading: 'Подача заявки на покупку/продажу',
              selected: false,
            },
            {
              id: '2.4',
              heading: 'Регистрация/отмена регистрации на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Заявки',
          expanded: false,
          items: [
            {
              id: '3.1',
              heading: 'Просмотр заявки, подробной информации по заявке',
              selected: false,
            },
            {
              id: '3.2',
              heading: 'Редактирование, отмена, удаление заявки',
              selected: false,
            },
            {
              id: '3.3',
              heading: 'Передача заявки другому трейдеру',
              selected: false,
            },
            {
              id: '3.4',
              heading: 'Просмотр задатка по заявке, задатка на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Торги сегодня',
          expanded: false,
          items: [
            {
              id: '4.1',
              heading: 'Переход в торги',
              selected: false,
            },
            {
              id: '4.2',
              heading: 'Просмотр заявки',
              selected: false,
            },
            {
              id: '4.3',
              heading: 'Редактирование заявки',
              selected: false,
            },
            {
              id: '4.4',
              heading:
                'Добавление заявки в наблюдаемые/удаление из наблюдаемых',
              selected: false,
            },
            {
              id: '4.5',
              heading: 'Регистрации',
              selected: false,
            },
            {
              id: '4.6',
              heading: 'Просмотр задатка по заявке',
              selected: false,
            },
            {
              id: '4.7',
              heading: 'Подача ставки',
              selected: false,
            },
            {
              id: '4.8',
              heading: 'Встречные предложения',
              selected: false,
            },
            {
              id: '4.9',
              heading: 'Сделки',
              selected: false,
            },
            {
              id: '4.10',
              heading: 'Торги',
              selected: false,
            },
            {
              id: '4.11',
              heading: 'Сообщения',
              selected: false,
            },
            {
              id: '4.12',
              heading: 'Товары-аналоги',
              selected: false,
            },
          ],
        },
      ];

      this.faqs = FAQ_DATA_TRADER;

      this.faqsForDisplay = this.faqs.filter((i) => {
        return i.topicId === '1.1';
      });

      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.forTrader === true && i.parentId == 1;
      });
    }
    this.store.dispatch(initializeApiData({ sessionKey: this.user?.token || '' }));
    this.sections$ = this.store.select(selectApiDataSections);
    this.getTodaySessions();
    this.user.IsWorker ? this.getNews(false) : this.getNews();
    this.currentTimeDate = new Date();

    new Splide('.splide', {
      type: 'loop',
      // perPage    : 1,
      padding: {left: '0%', right: '35%'},
      rewind: true,
      // heightRatio : 0.4,
      width: `100%`,
      // breakpoints: {
      //   1920: {
      //     padding: {left: '0', right: '0'},
      //   },
      //   1440: {
      //     padding: {left: '0', right: '0'},
      //     fixedWidth: '50rem'
      //   },
      // },
      autoplay: true,
    }).mount();
  }

  scrollToGuide() {
    document.querySelector('#guides').scrollIntoView({behavior: 'smooth'});
  }

  // change ROLE in guide wrapper
  togglegGuide(id) {
    this.guide.forEach((item) => {
      item.selected = item.id === id;
    });
    this.selectedGuide = this.guide.find((i) => i.selected == true).id;
    if (!this.user?.token || !this.user.IsWorker) {
      this.guideElementsForDisplay = this.guideElements.filter((i) => {
        return i.parentId === id && i.forTrader == true;
      });
    }
    if (this.user.IsWorker) {
      if (this.selectedGuide == 2) {
        if (this.isTraderActive) {
          this.guideElementsForDisplay = this.guideElements.filter((i) => {
            return i.parentId === id && i.forWorker == false && i.forTrader == true;
          });
        } else
        if (this.isWorkerActive) {
          this.guideElementsForDisplay = this.guideElements.filter((i) => {
            return i.parentId === id && i.forWorker == true && i.forTrader == false;
          });
        }
      } else {
        this.guideElementsForDisplay = this.guideElements.filter((i) => {
          return i.parentId === id && i.forWorker == true;
        });
      }
    }
  }

  viewDocs(type: string) {
    if (type == 'trader') {
      this.isTraderActive = true;
      this.isWorkerActive = false;
      if (this.selectedGuide == 2) {
        //переключение имеет смысл только на вкладке ТОрги, остлаьные доки общие
        this.guideElementsForDisplay = this.guideElements.filter((i) => {
          return i.forWorker == false && i.forTrader == true;
        });
      }
    }
    if (type == 'worker') {
      this.isWorkerActive = true;
      this.isTraderActive = false;
      if (this.selectedGuide == 2) {
        this.guideElementsForDisplay = this.guideElements.filter((i) => {
          return i.forWorker == true && i.forTrader == false;
        });
      }
    }

    this.toggleTopicByRole(type);
  }

  toggleTopicByRole(type: string) {
    if (type == 'trader') {
      this.topics = [
        {
          title: 'Каталог',
          expanded: true,
          items: [
            {
              id: '1.1',
              heading: 'Переход в Каталог спроса/Каталог предложений',
              selected: true,
            },
            {
              id: '1.2',
              heading: 'Просмотр, редактирование, отмена заявки',
              selected: false,
            },
            {
              id: '1.3',
              heading: 'Регистрация/отмена регистрации на сессию',
              selected: false,
            },
            {
              id: '1.4',
              heading: 'Подача заявки на покупку/продажу',
              selected: false,
            },
            {
              id: '1.5',
              heading: 'Просмотр сумма задатка по заявке/на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Расписание сессий',
          expanded: false,
          items: [
            {
              id: '2.1',
              heading: 'Просмотр расписания сессий, заявок',
              selected: false,
            },
            {
              id: '2.2',
              heading: 'Просмотр суммы задатка на сессию',
              selected: false,
            },
            {
              id: '2.3',
              heading: 'Подача заявки на покупку/продажу',
              selected: false,
            },
            {
              id: '2.4',
              heading: 'Регистрация/отмена регистрации на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Заявки',
          expanded: false,
          items: [
            {
              id: '3.1',
              heading: 'Просмотр заявки, подробной информации по заявке',
              selected: false,
            },
            {
              id: '3.2',
              heading: 'Редактирование, отмена, удаление заявки',
              selected: false,
            },
            {
              id: '3.3',
              heading: 'Передача заявки другому трейдеру',
              selected: false,
            },
            {
              id: '3.4',
              heading: 'Просмотр задатка по заявке, задатка на сессию',
              selected: false,
            },
          ],
        },
        {
          title: 'Торги сегодня',
          expanded: false,
          items: [
            {
              id: '4.1',
              heading: 'Переход в торги',
              selected: false,
            },
            {
              id: '4.2',
              heading: 'Просмотр заявки',
              selected: false,
            },
            {
              id: '4.3',
              heading: 'Редактирование заявки',
              selected: false,
            },
            {
              id: '4.4',
              heading:
                'Добавление заявки в наблюдаемые/удаление из наблюдаемых',
              selected: false,
            },
            {
              id: '4.5',
              heading: 'Регистрации',
              selected: false,
            },
            {
              id: '4.6',
              heading: 'Просмотр задатка по заявке',
              selected: false,
            },
            {
              id: '4.7',
              heading: 'Подача ставки',
              selected: false,
            },
            {
              id: '4.8',
              heading: 'Встречные предложения',
              selected: false,
            },
            {
              id: '4.9',
              heading: 'Сделки',
              selected: false,
            },
            {
              id: '4.10',
              heading: 'Торги',
              selected: false,
            },
            {
              id: '4.11',
              heading: 'Сообщения',
              selected: false,
            },
            {
              id: '4.12',
              heading: 'Товары-аналоги',
              selected: false,
            },
          ],
        },
      ];

      this.faqs = FAQ_DATA_TRADER;

      this.faqsForDisplay = this.faqs.filter((i) => {
        return i.topicId === '1.1';
      });
    }
    if (type == 'worker') {
      this.topics = [
        {
          title: 'Каталог',
          expanded: true,
          items: [
            {
              id: '1.1',
              heading: 'Каталог спроса/Каталог предложений',
              selected: true,
            },
          ],
        },
        {
          title: 'Сессии',
          expanded: false,
          items: [
            {
              id: '2.1',
              heading: 'Расписание сессий',
              selected: false,
            },
            {
              id: '2.2',
              heading: 'Создание сессий',
              selected: false,
            },
            {
              id: '2.3',
              heading: 'Создание шаблона сессии',
              selected: false,
            },
            {
              id: '2.4',
              heading: 'Просмотр сессии, шаблонов сессии',
              selected: false,
            },
            {
              id: '2.5',
              heading:
                'Копирование, редактирование, удаление сессии, шаблона сессии',
              selected: false,
            },
            {
              id: '2.6',
              heading: 'Синхронизация сессии',
              selected: false,
            },
            {
              id: '2.7',
              heading:
                'Перевод в стадию «Открыт прием заявок…», завершение обработки заявок',
              selected: false,
            },
            {
              id: '2.8',
              heading: 'Перенос в торги, в архив',
              selected: false,
            },
          ],
        },
        {
          title: 'Заявки',
          expanded: false,
          items: [
            {
              id: '3.1',
              heading: 'Управление заявками',
              selected: false,
            },
            {
              id: '3.2',
              heading: 'Конструктор моделей',
              selected: false,
            },
            {
              id: '3.3',
              heading: 'Конструктор правил',
              selected: false,
            },
            {
              id: '3.4',
              heading: 'Архив',
              selected: false,
            },
          ],
        },
        {
          title: 'Торги сегодня',
          expanded: false,
          items: [
            {
              id: '4.1',
              heading: 'Торги',
              selected: false,
            },
            {
              id: '4.2',
              heading: 'Период сессии',
              selected: false,
            },
            {
              id: '4.3',
              heading: 'Шаг цены',
              selected: false,
            },
            {
              id: '4.4',
              heading: 'Ставки',
              selected: false,
            },
            {
              id: '4.5',
              heading: 'Регистрации',
              selected: false,
            },
            {
              id: '4.6',
              heading: 'Трейдеры',
              selected: false,
            },
            {
              id: '4.7',
              heading: 'Заявки',
              selected: false,
            },
            {
              id: '4.8',
              heading: 'Задаток',
              selected: false,
            },
            {
              id: '4.9',
              heading: 'Встречные предложения',
              selected: false,
            },
            {
              id: '4.10',
              heading: 'Сделки',
              selected: false,
            },
            {
              id: '4.11',
              heading: 'Сообщения',
              selected: false,
            },
            {
              id: '4.12',
              heading: 'Перенос в архив',
              selected: false,
            },
          ],
        },
      ];

      this.faqs = FAQ_DATA;

      this.faqsForDisplay = this.faqs.filter((i) => {
        return i.topicId === '1.1';
      });
    }
  }

  toggleTopic(topic) {
    topic.expanded = !topic.expanded;
  }

  selectTopic(id) {
    this.topics.forEach((topic) => {
      topic.items.forEach((item) => {
        item.selected = item.id === id;
      });
    });

    this.faqsForDisplay = this.faqs.filter((i) => {
      return i.topicId === id;
    });
  }

  toggle(index: number) {
    this.faqsForDisplay[index].open = !this.faqsForDisplay[index].open;
  }

  onSearchChange() {
    const term = this.searchTerm.toLowerCase();
    if (term?.length > 3) {
      this.faqsForDisplay = this.faqs.filter(
        (faq) =>
          faq.question.toLowerCase().includes(term) ||
          faq.answer.toLowerCase().includes(term)
      );
    } else {
      this.faqsForDisplay = [];
    }
  }

  isAcceptableRole() {
    return this.accreditedRoleService.getRole() != '0';
  }

  downloadFile(id) {
    const getPath = (id: number) =>
      this.guideElements.find((item) => item.id === id);
    const _url = getPath(id).path;
    this.http
      .get(`${this.config.host}` + _url, {responseType: 'blob'})
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sample.pdf';
        a.click();
      });
  }

  openLink(index) {
    const getPath = (id: number) =>
      this.guideElements.find((item) => item.id === index);
    window.open(getPath(index).path, '_blank');
  }

  getTodaySessions() {
    this.startService
      .GetTodaySessionsList(this.user?.token)
      .then((res: any) => {
        this.sessions = res.sessions;
        this.filterSessionByTab();
      });
  }

  onChangeTab(e: any) {
    this.filterTab = e.itemIndex;
    this.filterSessionsId = e.itemData?.id;
    this.filterSessionByTab();
  }

  filterSessionByTab() {
    this.sessionsForDisplay = this.sessions.filter(
      (el: any) => el.sectionId == this.filterSessionsId
    );
  }

  getNews(isActive?: boolean) {
    this.loadingVisible = true;

    try {
      if (this.user.IsWorker) {
        this.startService
          .GetNewsListNewWorker(this.user?.token, this.currentPage, isActive)
          .then((res: any) => {
            //
            this.news = res.news;
            this.fullNews = res.news;

            if (res.news.length > 0) {
              this.currentPage = res.news ? res.news[0]?.curPage : 1;
              this.totalPages = res.news ? res.news[0]?.totalPages : 1;
              this.news.forEach((el: any) => {
                el.newsBody.replace(/\n\r?/g, '<br />');
                el.isEdit = false; //для открытия формы редактирования
              });
              if (
                isActive == false &&
                this.formActive.get('onlyActive')?.value == true
              ) {
                this.onFilterNews({value: true});
              }
            } else {
              this.currentPage = 1;
              this.totalPages = 1;
            }
            this.loadingVisible = false;
            //console.log('newsW', this.news);
          });
      } else {
        this.startService
          .GetNewsListNew(this.user?.token, this.currentPage)
          .then((res: any) => {
            this.news = res.news;
            if (res.news.length > 0) {
              this.currentPage = res.news[0]?.curPage;
              this.totalPages = res.news[0]?.totalPages;
              this.news.forEach((el: any) => {
                el.newsBody.replace(/\n\r?/g, '<br />');
              });
            } else {
              this.currentPage = 1;
              this.totalPages = 1;
            }

            this.loadingVisible = false;
            // console.log('news', this.news);
          });
      }
    } catch (error) {
      this.loadingVisible = false;
    }
  }

  openEditNews(id: number) {
    this.news.forEach((el: any) => {
      if (el.idNews == id) {
        el.isEdit = true; //для открытия формы редактирования
        this.editDisable = true;
        this.form.get('titleNews')?.patchValue(el.newsTitle);
        this.form.get('newsContent')?.patchValue(el.newsBody);
        const datePublish = (el.datePublish - 25569) * 24 * 3600 * 1000;
        this.form.get('datePublish')?.patchValue(datePublish);
      }
    });
  }

  openEditNews2(id: number): void {
    if (this.newsWrapper?.nativeElement) {
      this.savedScrollY = this.newsWrapper.nativeElement.scrollTop;
    }

    const item = this.news.find(n => n.idNews === id);
    if (!item) return;

    this.isEdit = true;
    this.editDisable = true;
    this.editingNewsId = id;

    const datePublish = (item.datePublish - 25569) * 24 * 3600 * 1000;

    this.formEdit.patchValue({
      idNews: item.idNews,
      titleNews: item.newsTitle,
      newsContent: item.newsBody,
      datePublish: datePublish
    });

    this.newsContent = item.newsBody;
  }

  closeEditNews(id: number) {
    this.news.forEach((el: any) => {
      if (el.idNews == id) {
        this.isEdit = false; //для открытия формы редактирования
        this.editDisable = false;
        this.formEdit.get('titleNews')?.patchValue(null);
        this.formEdit.get('newsContent')?.patchValue(null);
        this.formEdit.get('datePublish')?.patchValue(null);

        setTimeout(() => {
          if (this.newsWrapper?.nativeElement) {
            this.newsWrapper.nativeElement.scrollTop = this.savedScrollY;
          }
        }, 0);
      }
    });
  }

  addNews(type: string, id?: number) {
    //переводти дату в числовой формат
    let numberTodayTime = this.startService.toOADate(this.currentTimeDate);
    let body;

    if (this.form.get('newsContent')?.value.includes('data:image')) { //если картинка вставлена из буфера в формате base64 - предупреждение что так нельзя
      alert('Вставка изображений из буфера запрещена.\nИспользуйте вставку изображения по URL.');
    } else {
      if (type == 'add') {
        let numberPublishTime = this.startService.toOADate(
          this.form.get('datePublish')?.value
        );

        body = {
          newsTitle: this.form.get('titleNews')?.value,
          newsBody: this.form.get('newsContent')?.value,
          datePublish: this.form.get('datePublish')?.value
            ? numberPublishTime
            : numberTodayTime,
        };
      }

      if (type == 'edit') {
        let numberPublishTime = this.startService.toOADate(
          this.formEdit.get('datePublish')?.value
        );

        body = {
          idNews: id,
          newsTitle: this.formEdit.get('titleNews')?.value,
          newsBody: this.formEdit.get('newsContent')?.value,
          datePublish: this.formEdit.get('datePublish')?.value
            ? numberPublishTime
            : numberTodayTime,
        };
      }

       // console.log(body)
    this.startService.SetNews(this.user?.token, body).then((res: any) => {

      // reset variables
      this.addNewsBody = false;
      this.editDisable = false;
      this.isEdit = false;
      this.editingNewsId = null;

      if (type == 'edit') {
        this.formEdit.get('titleNews')?.patchValue(null);
        this.formEdit.get('newsContent')?.patchValue(null);
        this.formEdit.get('datePublish')?.patchValue(null);
      } else {
        this.form.get('titleNews')?.patchValue(null);
        this.form.get('newsContent')?.patchValue(null);
        this.form.get('datePublish')?.patchValue(null);
      }

      // get list of news
      this.getNews(this.formActive.get('onlyActive')?.value);

      setTimeout(() => {
        if (this.newsWrapper?.nativeElement) {
          this.newsWrapper.nativeElement.scrollTop = this.savedScrollY;
        }
      }, 0);
    });
    }
  }

  closeAddForm() {
    this.addNewsBody = false;
    this.form.get('titleNews')?.patchValue(null);
    this.form.get('newsContent')?.patchValue(null);
    this.form.get('datePublish')?.patchValue(null);
  }

  onFilterNews(e: any) {
    this.getNews(this.formActive.get('onlyActive')?.value);
    /*  if(e.value == true){

      this.news = this.news.filter((el: any) => {
        return el.isActive == true
      });
    }else {
      this.news = this.fullNews
    } */
  }

  changeNewsActivity(id: number) {
    this.startService
      .ChangeNewsActivity(this.user?.token, {idNews: id})
      .then((res: any) => {
        this.getNews(this.formActive.get('onlyActive')?.value);
      });
  }

  getSafeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  goToCatalog(direction: number, sectionId: number = null) {
    const sessionStorageKey =
    direction === IdDirection.buy
      ? 'CATALOG_BUY'
      : 'CATALOG_SALE';

    let cache = {
      filters: {
        sections: sectionId //отправляем секцию для предзаполнения фильтра Секция
      }
    };

    sessionStorage.setItem(sessionStorageKey, JSON.stringify(cache));

    const baseUrl = `${this.config.host}${this.config.orderMan}/catalog`;

    const queryParams = new URLSearchParams({
      direction: String(direction)
    });

    window.location.href = `${baseUrl}?${queryParams.toString()}`;
  }

  goToLink(data: any) {
    if (!this.user?.token) {
      if (!data.isFromNewSystem) {
        //проверяем НТС или нет
        const datepipe: DatePipe = new DatePipe('en-US'); //задает формат даты
        const date = datepipe.transform(this.today, 'yyyy-MM-dd');
        const str = `https://www.butb.by/shedule/?date=${date}&section=${data.sectionId}`;
        window.open(str, '_blank');
        //   window.location.href = str;
      } else {
        //переход на логин
        const lang = this.cookieService.get('UasLang').toLowerCase();
        const returnurl = document.location.href.replace(/\//g, '%2F');
        const encodedReturnUrl = encodeURIComponent(returnurl);

        const str = `${this.config.uas_front}/ppts/false/${lang}/token;returnUrl=${encodedReturnUrl};errorUrl=null`;
        window.location.href = str;
      }
    }

    if (!data.isArchived && this.user?.token) {
      if (!data.isFromNewSystem) {
        //переход на биржевой сайт
        const datepipe: DatePipe = new DatePipe('en-US'); //задает формат даты
        const date = datepipe.transform(this.today, 'yyyy-MM-dd');
        //console.log('date', date)
        const str = `https://www.butb.by/shedule/?date=${date}&section=${data.sectionId}`;
        window.open(str, '_blank');
        //   window.location.href = str; // + "?jwt=" + this.user?.token;
      } else {
        //проверяем НТС или нет
        if (data.isTradingInProcess) {
          //переход в торги
          this.startService
            .sessionLogin(this.user?.token, data.sectionId, data.sessionId)
            .subscribe((res: ISessionLoginRes) => {
              this.isExistsViolations = res.isExistsViolations;

              let auctionsType = this.getAuctionPath(
                data.idAuctionType
              );

              const url = this.router.serializeUrl(
                this.router.createUrlTree(
                  [`${this.config.auctions}/${auctionsType}/main-page`],
                  {
                    queryParams: {
                      isExistsViolations: this.isExistsViolations,
                      idDirection: res.idDirection,
                      idSection: data.sectionId,
                      idSession: data.sessionId,
                    },
                  }
                )
              );
              window.open(url, '_blank');
            });
        } else {
          const offerSection = {
            sectionId: data.sectionId,
            sessionId: data.sessionId,
          };
          localStorage.setItem('offerSection', JSON.stringify(offerSection));
          const str = `${this.config.host}${this.config.orderMan}/offer-management`;
          //  console.log('str', str)
          window.location.href = str;
        }
      }
    }
  }

  public getAuctionPath(type: number): string {
    switch (type) {
      case AuctionType.englishUpgrading:
        return 'english-upgrading-auction';
      case AuctionType.dutchDown:
        return 'dutch-down-auction';
      case AuctionType.doubleCounter:
        return 'double-counter-auction';
      default:
        return 'english-upgrading-auction';
    }
  }

  onChangePage(e: any) {
    this.currentPage = e;
    this.user.IsWorker
      ? this.getNews(this.formActive.get('onlyActive')?.value)
      : this.getNews();
  }

  openStructurePage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`landingpage/structure`])
    );
    window.open(url, '_blank');
  }

  loginEcpBy() {
    //const returnUrl = document.location.href.replace(/\//g, '%2F');

    const str = `${this.config.ecpby}`;
    window.location.href = str;

  }

}
